
import { IonCardContent, IonButton, useIonAlert } from '@ionic/react';
import { useState } from "react";
import { Redirect, } from 'react-router-dom';

import { handleDidntReceiveOtpButton, handleOtpVerification } from "../services/actionHandlers"
import { setCookie } from "../../../utils/cookie"

import { GlobalStore } from "../../../store/GlobalStore";

function OtpContent(){ 
    const { getUserLoginDetails , setUserLoginDetails } = GlobalStore()
    const userLoginData = getUserLoginDetails()

    const [present] = useIonAlert()

    const [otp, setOtp] = useState("")
    const [redirectToBooking , setRedirectToBooking] = useState(false)
    const [redirectToSignUp , setRedirectToSignUp] = useState(false)


    const handleRetryOtp = async () => {
        let response = await handleDidntReceiveOtpButton(userLoginData)
                    if (response.status) {
                        present({
                            message: "OTP sent",
                            buttons: [
                                    'Ok'
                            ],
                        })
                    }
    }

    const handleSubmitOtp = async () => {

        let response = await handleOtpVerification(userLoginData, otp)
        if (response.status && !userLoginData.newUser) {
            // setCookie("RydeSendToken", response.data.token)
            setCookie("RydeSendToken", response.data.rydeSendToken)
            setRedirectToBooking(true)
            return
        } 
        if (response.status && userLoginData.newUser ){
            setUserLoginDetails({...userLoginData , otp:otp})
            setRedirectToSignUp(true)
            return
        }
    }

    const handleOtpSubmission = async (otp) => {
        if (otp.length === 6) {
            let response = await handleOtpVerification(userLoginData, otp)
            if (response.status && !userLoginData.newUser) {
                // setCookie("RydeSendToken", response.data.token)
                setCookie("RydeSendToken", response.data.rydeSendToken)
                setRedirectToBooking(true)
                return
            } 
            if (response.status && userLoginData.newUser ){
                setUserLoginDetails({...userLoginData , otp:otp})
                setRedirectToSignUp(true)
                return
            }
            if(!response.status) {
                
                present({
                    message: response.error,
                    buttons: [
                            'Ok'
                    ],
                })
            }
        }
    }

    return (
        <>
            <IonCardContent className='otp-label'>
            
                <div className='custom-label'>
                    <ion-label >OTP</ion-label>
                    <input type="text" className='custom-input-verify' placeholder="" maxLength="6" onChange={(e)=> handleOtpSubmission(e.target.value)}/>
                </div>
                <a className='otp-link' onClick={handleRetryOtp}>Didn’t receive OTP?</a>
                
                
                {
                    redirectToBooking &&
                    <Redirect to="/booking"/>
                }
                {
                    redirectToSignUp &&
                    <Redirect to="/signup"/>
                }
            </IonCardContent>
        </>
    )
}

export default OtpContent;